import template from './icon-sprite.generated.html';

export const IconSpriteComponent = {
  name: 'iconSprite',
  restrict: 'E',
  template
};



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-icon/src/sprite/icon-sprite.component.js